<template>
  <basic-container>
    <el-tabs v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane label="待重启" name="first">
       
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          ref="crud"
          @on-load="onLoad"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
          @selection-change="selectionChange"
        >
        <template slot="search">
          <el-form
          :model="searchForm"
          ref="searchFormRef"
          label-width="100px"
          label-suffix=":"
        
        >
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="充电桩编号" prop="deviceCode">
                <el-input
                  clearable
                  v-model="searchForm.deviceCode"
                  placeholder="充电桩编号"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属租户" prop="tenantId">
                <el-select
                  v-model="searchForm.tenantId"
                  style="width: 100%"
                  placeholder="所属租户"
                  clearable
                >
                  <el-option
                    v-for="item in tenantList"
                    :key="item.tenantId"
                    :label="item.tenantName"
                    :value="item.tenantId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属代理商" prop="agentId">
                <el-select
                  v-model="searchForm.agentId"
                  style="width: 100%"
                  clearable
                  placeholder="所属代理商"
                >
                  <el-option
                    v-for="item in agentList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属小区" prop="areaId">
                <el-select
                  v-model="searchForm.areaId"
                  style="width: 100%"
                  placeholder="所属小区"
                  clearable
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="所属充电站" prop="stationId">
                <el-select
                  v-model="searchForm.stationId"
                  style="width: 100%"
                  placeholder="所属充电站"
                  clearable
                >
                  <el-option
                    v-for="item in stationList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <div style="float: right">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="searchRecord"
                  size="small"
                >
                  搜索
                </el-button>
                <el-button
                  icon="el-icon-delete"
                  @click="searchClear"
                  size="small"
                >
                  清空
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        </template>
        
          <template slot="address" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.address"
              placement="top"
            >
              <div class="txtOver">{{ scope.row.address }}</div>
            </el-tooltip>
          </template>
          <template slot="description" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.address"
              placement="top"
            >
              <div class="txtOver">{{ scope.row.address }}</div>
            </el-tooltip>
          </template>
        </avue-crud>
      </el-tab-pane>
      <el-tab-pane label="重点关注区域" name="second">
    
        <avue-crud
          :option="optionSelf"
          :table-loading="loadingSelf"
          :data="dataSelf"
          :page.sync="pageSelf"
          ref="crudSelf"
          @on-load="onLoadSelf"
          @current-change="currentChangeSelf"
          @size-change="sizeChangeSelf"
          @refresh-change="onLoadSelf"
          @selection-change="selectionChangeSelf"
        >
        <template slot="search">
          <el-form
          :model="searchFormSelf"
          ref="searchFormRefSelf"
          label-width="100px"
          label-suffix=":"
         
        >
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="小区名称" prop="areaName">
                <el-input
                  clearable
                  v-model="searchFormSelf.areaName"
                  placeholder="小区名称"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属租户" prop="tenantId">
                <el-select
                  v-model="searchFormSelf.tenantId"
                  style="width: 100%"
                  placeholder="所属租户"
                  clearable
                >
                  <el-option
                    v-for="item in tenantListSelf"
                    :key="item.tenantId"
                    :label="item.tenantName"
                    :value="item.tenantId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属代理商" prop="agentId">
                <el-select
                  v-model="searchFormSelf.agentId"
                  style="width: 100%"
                  placeholder="所属代理商"
                >
                  <el-option
                  clearable
                    v-for="item in agentListSelf"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="所属小区" prop="areaId">
                <el-select
                  v-model="searchFormSelf.areaId"
                  style="width: 100%"
                  placeholder="所属小区"
                  clearable
                >
                  <el-option
                    v-for="item in areaListSelf"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item label="所属充电站" prop="stationId">
                <el-select
                  v-model="searchFormSelf.stationId"
                  style="width: 100%"
                  placeholder="所属充电站"
                  clearable
                >
                  <el-option
                    v-for="item in stationListSelf"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <div style="float: right">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="searchRecordSelf"
                  size="small"
                >
                  搜索
                </el-button>
                <el-button
                  icon="el-icon-delete"
                  @click="searchClearSelf"
                  size="small"
                >
                  清空
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        </template>
        <template slot="menu" slot-scope="scope">
               
                  <el-button
                type="text"
                size="small"
                
                @click="remove(scope.row)"
                >
                移除
                </el-button>
               
            </template>
          <template slot="menuLeft">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addRecord"
            >
              新 增</el-button
            >
          </template>
          
         
        </avue-crud>
      </el-tab-pane>
    </el-tabs>

    <hr-dialog
      :title="recordTittle"
      :allowFull="false"
      width="60%"
      :visible.sync="visible"
    >
      <template slot="body">
        <AddKeyAdressVue
          @cancle="recordCancle"
          v-if="visible"
          :model="model"
          :row="tenantInfoRow"
          @success="recordSuccess"
        ></AddKeyAdressVue>
      </template>
    </hr-dialog>
  </basic-container>
</template>
<script>
import { getDictionary } from "@/api/common.js";
import searchFromShow from "@/components/search-form-show/index";
import {
  tenantGetList,
  agentGetList,
  propertyGetList,
  areaGetList,
  stationGetList,
  getRestartDevicePage,
  getRestartStationPage,
  removeEmphasisStation
} from "./api/index";
import AddKeyAdressVue from "./addKeyAdress.vue";
export default {
  components: { searchFromShow,AddKeyAdressVue },
  data() {
    return {
      tenantList: [],
      agentList: [],
      propertyList: [],
      areaList: [],
      stationList: [],
      tenantListSelf: [],
      agentListSelf: [],
      propertyListSelf: [],
      areaListSelf: [],
      stationListSelf: [],
      activeName: "first",
      dataSelf:[],
      data:[],
      visible: false,
      recordTittle: "新增",
      configureTittle: "配置",
      searchForm: {
        deviceCode: "",
        tenantId: "",
        agentId: "",
        areaId: "",
        stationId: "",
      },
      searchFormSelf: {
        areaName: "",
        tenantId: "",
        agentId: "",
        areaId: "",
        stationId: "",
      },
      option: {
        indexFixed:false,
        index: true,
        indexLabel: "#",
        height: 'auto',
        calcHeight: 120,
        stripe: true,
        border: true,
        index: true,
        menu: false,
        searchBtn:false,
        emptyBtn:false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: "充电桩编号",
            prop: "deviceCode",
          },
          {
            label: "离线时间",
            prop: "eventTime",
          },
          {
            label: "所属充电站",
            prop: "stationName",
          },
          {
            label: "所属小区",
            prop: "areaName",
          },
          {
            label: "所属代理商",
            prop: "agentName",
          },
          {
            label: "所属租户",
            prop: "tenantName",
          },
        ],
      },
      optionSelf: {
        menuFixed:false,
        indexFixed:false,
        indexLabel: "#",
        height: 'auto',
        calcHeight: 300,
        stripe: true,
        border: true,
        index: true,
        menu: true,
        searchBtn:false,
        emptyBtn:false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          // {
          //   label: "充电站名称",
          //   prop: "stationName",
          // },
          {
            label: "小区名称",
            prop: "areaName",
          },
          {
            label: "所属代理商",
            prop: "agentName",
          },
          {
            label: "所属租户",
            prop: "tenantName",
          },
          
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      pageSelf: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      loadingSelf: false,
      searchBoxFlag: true,
      searchBoxFlagSelf:true,
      searchHeight: "",
      searchHeightSelf: "",
    };
  },
  watch: {
    
    "searchForm.tenantId"(value) {
      this.searchForm.agentId = "";
      this.agentList =[]
      if (value == "") {
      } else {
        //获取代理商
        this.agentGetList(value);
      }
    },
    "searchForm.agentId"(value) {
      this.searchForm.areaId = "";
      this.areaList=[]
      if (value == "") {
      } else {
        //获取小区
        this.areaGetList(value);
      }
    },

    "searchForm.areaId"(value) {
      this.searchForm.stationId = "";
      this.stationList =[]
      if (value == "") {
      } else {
        //获取小区
        this.stationGetList(value);
      }
    },
    "searchFormSelf.tenantId"(value) {
      this.searchFormSelf.agentId = "";
      this.agentListSelf =[]
      if (value == "") {
      } else {
        //获取代理商
        this.agentGetListSelf(value);
      }
    },
    "searchFormSelf.agentId"(value) {
      this.searchFormSelf.areaId = "";
      this.areaListSelf=[]
      if (value == "") {
      } else {
        //获取小区
        this.areaGetListSelf(value);
      }
    },

    "searchFormSelf.areaId"(value) {
      console.log('*111*')
      this.searchFormSelf.stationId = "";
      this.stationListSelf=[]
      if (value == "") {
      } else {
        //获取小区
        console.log('*22*')
        this.stationGetListSelf(value);
      }
    },
  },
  created() {
    // this.initData();
    this.tenantGetList();
    this.tenantGetListSelf();
  },
  mounted() {
    // this.calcHeight();
  },
  methods: {
    addRecord(){
      this.visible = true
    },
    remove(row){
      this.$confirm('是否进行移除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = new FormData()
            formData.append('ids',row.areaId)
          
          removeEmphasisStation(formData).then(res=>{
            this.$message({
            type: 'success',
            message: '移除成功!'
          });
          this.onLoadSelf()
          })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          });          
        });
    },
    stationGetList(value) {
      stationGetList({ areaId: value }).then((res) => {
        this.stationList = res.data;
      });
    },
    //获取租户下拉框
    tenantGetList() {
      tenantGetList().then((res) => {
        this.tenantList = res.data;
      });
    },
    //获取代理商
    agentGetList(value) {
      agentGetList({ tenantId: value }).then((res) => {
        this.agentList = res.data;
      });
    },

    //获取小区
    areaGetList(value) {
      areaGetList({ agentId: value }).then((res) => {
        this.areaList = res.data;
      });
    },

    stationGetListSelf(value) {
      console.log('***')
      stationGetList({ areaId: value }).then((res) => {
        this.stationListSelf = res.data;
      });
    },
    //获取租户下拉框
    tenantGetListSelf() {
      tenantGetList().then((res) => {
        this.tenantListSelf = res.data;
      });
    },
    //获取代理商
    agentGetListSelf(value) {
      agentGetList({ tenantId: value }).then((res) => {
        this.agentListSelf = res.data;
      });
    },

    //获取小区
    areaGetListSelf(value) {
      areaGetList({ agentId: value }).then((res) => {
        this.areaListSelf = res.data;
      });
    },
    disableUser(row) {
      this.$confirm("是否禁用用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        tenantUpdateStatus({ status: 2, id: row.id }).then(() => {
          this.$message.success("禁用成功");
          this.onLoad();
        });
      });
    },
    startUpUser(row) {
      this.$confirm("是否启用用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        tenantUpdateStatus({ status: 1, id: row.id }).then(() => {
          this.$message.success("启用成功");
          this.onLoad();
        });
      });
    },
    recordCancle() {
      this.passwordVisible = false;
      this.merchantVisible = false;
      this.visible = false;
    },

    configureCanteen(row) {
      this.configureRow = row;
      this.passwordVisible = true;
    },
    recordSuccess() {
      this.visible = false;
     
      this.onLoadSelf();
    },
 
    searchRecord() {
      this.page.currentPage = 1;

      this.onLoad();
    },
    searchRecordSelf(){
      this.pageSelf.currentPage = 1;

      this.onLoadSelf();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm);
    },
    searchClearSelf(){
      this.tool.clearObject(this.searchFormSelf);
    },
    handleClick(){
      console.log(this.activeName)
      if(this.activeName!='first'){
        // this.optionSelf.height = this.bodyHeight  -300;
        this.optionSelf.calcHeight =120
       
        // this.searchHeightSelf = this.$refs.searchFormRefSelf.$el.clientHeight;
       
        // this.$set( this.optionSelf,'height',this.bodyHeight - this.searchHeightSelf - 330)
        // console.log(this.optionSelf.height)
        // this.$forceUpdate()
      }
      
    },
    calcHeight() {
      if(this.activeName=='first'){
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 300;
      }else{
        console.log('zhongdian')
       
     
       
      }
     
      
     
    },
    async initData() {
      // await getProjectList().then((res) => {
      //   this.projectList = res.data;
      //   if (this.projectList.length > 0) {
      //     this.$set(this.searchForm, 'projectId', this.projectList[0].id);
      //   }
      // });
    },
    onLoad() {
        this.loading = true;
      getRestartDevicePage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onLoadSelf() {
        this.loadingSelf = true;
        getRestartStationPage(
        Object.assign(
          {},
          { current: this.pageSelf.currentPage, size: this.pageSelf.pageSize },
          this.searchFormSelf
        )
      )
        .then(({ data }) => {
          this.dataSelf = data.records;
          this.pageSelf.total = data.total;
          this.loadingSelf = false;
        })
        .catch(() => {
          this.loadingSelf = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
</style>
